import { render, staticRenderFns } from "./addCustomerDialog.vue?vue&type=template&id=1529cc78"
import script from "./addCustomerDialog.vue?vue&type=script&lang=js"
export * from "./addCustomerDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports